<mat-card class="dialog-container small-dialog">
    <div class="content-container">
        <img src="assets/images/lawyerly-notext-logo-whitebg.png" />

        <small>A new version of Lawyerly is available.</small>
    </div>

    <div class="footer">
        <div class="button-container">
            <button
                (click)="onCancel()"
                type="button"
                mat-button
                class="btn icon">
                <mat-icon>close</mat-icon>
                <span>Cancel</span>
            </button>
            <button
                (click)="onClick()"
                type="submit"
                mat-button
                class="btn icon button-blue save-button">
                <mat-icon>update</mat-icon>
                <span>Update</span>
            </button>
        </div>
    </div>
</mat-card>
